export const getNameByFile = (file: string): string => {
  const splitResult = file.split(/[/\\]/);
  return splitResult.pop() || '';
};
